module.exports = __webpack_public_path__ + "static/media/airplane-6.ce7aa06a.svg";